import { Box, Flex } from '@chakra-ui/react';
import { getUserL2Access } from 'Deer/helpers/getUserAccess';
import { useOpenCompetencyDrawer } from 'components/Develop/helpers/useOpenCompetencyDrawer';
import { useReviewPreviewParams } from 'screens/performanceReview/hooks/reviewPreviewHooks';
import useReviewFormParams from 'screens/performanceReview/hooks/useReviewFormParams';
import { checkFeedbackModuleEnabled } from 'utils/helpers/moduleAccess';

import { OpenInNew } from 'assets/assetsV1/iconComponents';

import { sendOpenedCompetencyPanelEvent } from 'constants/mixpanelHelpers/reviewsEvents';

import { Button } from 'uiToolkitV1/Button';
import { ProgressBar } from 'uiToolkitV1/ProgressBar';
import { SkeletonLoader } from 'uiToolkitV1/SkeletonLoader';
import { TooltipInfoV1 } from 'uiToolkitV1/TooltipInfoV1';
import { TextBodyMedium, TextLabelSmall } from 'uiToolkitV1/Typography';
import ViewMore from 'uiToolkitV1/ViewMore/ViewMore';

const CompetencySummary = ({ competencyId, competencyName, currentCompetencyData, competencyDescription }) => {
  const { employeeId, reviewId } = useReviewFormParams();
  const { openCompetencyPanel } = useOpenCompetencyDrawer();
  const { isPreview } = useReviewPreviewParams();

  const { progressDetails } = currentCompetencyData ?? {};

  const { displayScore, maxScore } = progressDetails ?? {};

  const showProgressBar = !!progressDetails;

  // undefined means not yet loaded, null means no competency found in data
  if (currentCompetencyData === undefined) {
    return (
      <Box p={4}>
        <SkeletonLoader />
      </Box>
    );
  }

  const onCompetencyClickHandler = () => {
    sendOpenedCompetencyPanelEvent({
      eventProperties: {
        reviewCycleId: reviewId,
        empId: employeeId,
      },
    });
    openCompetencyPanel({
      tagId: competencyId,
      tagTitle: competencyName,
      employeeId,
      hideShareFeedbackButtons: true,
    });
  };

  return (
    <Flex bg="#F5F7F9" p="16px" flexDir="column" pt={3}>
      <Flex justifyContent="space-between" alignItems="center" mb={6}>
        <TextBodyMedium bold>Competency Summary</TextBodyMedium>

        {checkFeedbackModuleEnabled() && (
          <Button
            StartIcon={OpenInNew}
            onClick={onCompetencyClickHandler}
            variant="outlinedSmall"
            iconSize="16px"
            p="0 6px 0 0"
            isDisabled={isPreview}
          >
            Open Competency
          </Button>
        )}
      </Flex>
      <div style={{ marginTop: '16px' }}>
        <ViewMore text={competencyDescription || ''} min={120} max={180} ideal={150} />
      </div>
      {getUserL2Access().hasIDPAccess && (
        <Flex style={{ marginTop: '28px' }}>
          {showProgressBar ? (
            <Flex flexDir="column" gap={1} w="100%">
              {/* @ts-expect-error ProgressBar expects more props */}
              <ProgressBar
                size="large"
                color="#DBF2D3"
                backgroundColor="#CFD7DF"
                value={displayScore}
                max={maxScore}
                height="24px"
              />
              <Flex justifyContent="space-between">
                <TextLabelSmall color="text.g2">0</TextLabelSmall>
                <TextLabelSmall color="text.g2">{maxScore}</TextLabelSmall>
              </Flex>
            </Flex>
          ) : null}
          {showProgressBar && (
            <TooltipInfoV1
              ml="6px"
              title="Maven calculates the progress on the basis of quality, relevance and frequency of feedback received for this competency"
            />
          )}
        </Flex>
      )}
    </Flex>
  );
};

export default CompetencySummary;
